import { useCallback, useState } from "react";

export const useUBO = (initialState = { type: '', data: {} }) => {
    const [uboState, setUBOState] = useState(initialState);

    // Memoised: child forms list this in effect dependencies, so a fresh identity
    // each render made those effects fire on every render.
    const updateUBOState = useCallback((action) => {
        switch (action.type) {
            case "CHANGE_TYPE":
                setUBOState((prev)=>({
                    ...prev,
                    type: action.payload,
                    data: {}
                }))
                break;
            case "CHANGE_PERCENTAGE":
                setUBOState(prev => ({
                    ...prev,
                    percentage: action.payload
                }));
                break;
            case "UPDATE_FIELD":
                setUBOState(prev => ({
                    ...prev,
                    data: {
                        ...prev.data,
                        [action.payload.field]: action.payload.value
                    }
                }));
                break;
            default:
                return;
        }
    }, []);

    // setUBOState is exposed so a parent-side replacement (e.g. a refetch after save)
    // can overwrite the copy this hook seeded on mount.
    return [uboState, updateUBOState, setUBOState];

}